import React from 'react';
import "../Error.scss"
import ClipLoader from "react-spinners/ClipLoader";
import { FIELD_MAX_LENGTHS } from '../../../../Utils/Constants';

const InfoTab = ({ formData, setFormData, isEditMode = false, isLoading, roles = [], errors = {} }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="aptab-inner">
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
          <ClipLoader size={35} color="gray" />
        </div>
      ) : (
        <>
          <div className="cp-split">
            <label className="fi-label">Email<span>*</span></label>
            <input type="text" name="email_id" maxLength={FIELD_MAX_LENGTHS.email} className={`common-input ${!isEditMode ? 'readonly-input' : ''} ${errors.email_id ? 'error' : ''}`} value={formData.email_id} disabled onChange={handleChange} />
            {errors.email_id && <div className="error-text active">{errors.email_id}</div>}
          </div>

          <div className="cp-split">
            <label className="fi-label">Permission Name<span>*</span></label>
            <select name="role_id" className={`common-select ${!isEditMode ? 'readonly-input' : ''} ${errors.role_id ? 'error' : ''}`} value={formData.role_id} disabled={!isEditMode} onChange={handleChange}>
              {isEditMode ? (
                <>
                  <option value="">--Select--</option>
                  {roles.map(role => (
                    <option key={role.id} value={role.id}>{role.role_name}</option>
                  ))}
                </>
              ) : (
                <option value={formData.role_id}>{formData.role_name}</option>
              )}
            </select>
            {errors.role_id && <div className="error-text active">{errors.role_id}</div>}
          </div>

          <div className="cp-split">
            <label className="fi-label">First Name<span>*</span></label>
            <input type="text" name="first_name" maxLength={FIELD_MAX_LENGTHS.firstName} className={`common-input ${!isEditMode ? 'readonly-input' : ''} ${errors.first_name ? 'error' : ''}`} value={formData.first_name} disabled={!isEditMode} onChange={handleChange} />
            {errors.first_name && <div className="error-text active">{errors.first_name}</div>}
          </div>

          <div className="cp-split">
            <label className="fi-label">Last Name<span>*</span></label>
            <input type="text" name="last_name" maxLength={FIELD_MAX_LENGTHS.lastName} className={`common-input ${!isEditMode ? 'readonly-input' : ''} ${errors.last_name ? 'error' : ''}`} value={formData.last_name} disabled={!isEditMode} onChange={handleChange} />
            {errors.last_name && <div className="error-text active">{errors.last_name}</div>}
          </div>

          <div className="cp-split">
            <label className="fi-label">Contact No.<span>*</span></label>
            <input type="tel" name="contact_no" maxLength={FIELD_MAX_LENGTHS.contact} className={`common-input ${!isEditMode ? 'readonly-input' : ''} ${errors.contact_no ? 'error' : ''}`} value={formData.contact_no} disabled={!isEditMode} onChange={handleChange} />
            {errors.contact_no && <div className="error-text active">{errors.contact_no}</div>}
          </div>
        </>
      )}
    </div>
  );
};

export default InfoTab;
